<template>
  <div class="page">
    <van-list
        v-model="loading"
        :finished="listFinished"
        finished-text="没有更多了"
        @load="loadData"
    >
      <van-cell-group class="order-list">
        <van-cell
            v-for="(item, index) in list"
            :key="index"
            size="large"
            center
            clickable
            is-link
            :to="'/clerk/clerk-category-apply-detail/' + item.id"
        >
          <div class="order-item">
            <div class="left align-center">
              <div class="user_head">
                <van-image
                    round
                    width="60px"
                    height="60px"
                    :src="item.iconUrl ? item.iconUrl : null"
                >
                </van-image>
              </div>
              <div class="padding-left-sm">
                <div style="display: inline-block; margin-right: 4px">
                  <van-tag v-if="item.status == 0"
                  >待审核</van-tag
                  >
                  <van-tag v-else-if="item.status == 1" type="success"
                  >已通过</van-tag
                  >
                  <van-tag v-else-if="item.status == 2" type="danger"
                  >未通过</van-tag
                  >
                </div>
                <span>{{
                    item.name
                  }}</span>
                <div>
                  <span>{{ formatDate(item.createTime, "MM-DD HH:mm") }}</span>
                </div>
                <div
                    v-if="item.status == 2 && item.remark != null && item.remark != ''"
                    class="userMemo"
                >
                  未通过原因：{{ item.remark }}
                </div>
              </div>
            </div>
            <div class="right">
              <div class="text-center">
                <div v-if="item.orderFeedBackId">
                  <span style="color: #999999; font-size: 12px">已反馈</span>
                </div>
              </div>
            </div>
          </div>
        </van-cell>
      </van-cell-group>
    </van-list>

    <div class="bottom-bar">
      <van-button class="bottom-button" to="/clerk/categoryExamineApply">新增</van-button>
    </div>

    <!--  审核内容  -->
    <van-dialog v-model="clerkPostShow" title="不通过原因"
                :show-cancel-button="false" :show-confirm-button="false"
                :overlay="true" :close-on-click-overlay="true"
    >
      <van-field
          v-model="clerkPostReason"
          rows="2"
          autosize
          :disabled="true"
          type="textarea"
          maxlength="100"
          placeholder=""
      />
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import {Button,Image as VanImage, Toast,Cell,CellGroup, Dialog, Field, Icon, List, ImagePreview, Tab, Tabs, Tag} from 'vant';
import {deletedPost} from '@/api/clerk/post'
import {getCategoryList} from '@/api/clerk/category_examine_check'
import moment from "moment";
import Decimal from "decimal.js";

Vue.use(VanImage)
    .use(Cell)
    .use(CellGroup)
    .use(Button)
    .use(Toast)
    .use(Dialog)
    .use(Field)
    .use(Icon)
    .use(List)
    .use(Tab)
    .use(Tabs)
    .use(Tag)
    .use(ImagePreview)

export default {
  name: 'clerk-category-apply-list',
  data() {
    return {
      videoElement: [],
      list: [],
      loading: false,
      listFinished: false,
      immediateCheck: false,
      clerkPostReason: null,
      clerkPostShow: false,
      pageNo: 1,
      pageSize: 15,
      player: {
        id: null,
        audio: null
      }
    }
  },
  watch:{
    '$route' () {
      //当路由发生变化，刷新页面
      this.loadData(true)
    }
  },
  methods: {
    clerkPost(item){
      this.clerkPostReason = item.remark
      this.clerkPostShow = true
    },
    loadData(resetFirstPage) {
      Toast.loading({
        overlay: true,
        message: '加载中...'
      })
      // 重置为首页
      if (resetFirstPage) {
        this.pageNo = 1
      }
      // 清空数据
      if (this.pageNo == 1) {
        this.list = [];
      }
      this.loading = true
      getCategoryList(this.pageNo, this.pageSize).then(res => {
        Toast.clear()
        this.loading = false
        const data = res.data;
        if (data.code == 0) {
          this.list = this.list.concat(data.list)
          if (data.hasNextPage) {
            this.listFinished = false
          } else {
            this.listFinished = true
          }
        } else {
          this.listFinished = true
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
        this.pageNo++
      })
      this.videoElement = document.getElementsByTagName('video')
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    playAudio(id, audioUrl) {
      if (this.player.audio != null) {
        this.player.audio.pause()
      }
      if (this.player.id == id) {
        this.player.id = null
        this.player.audio = null
      } else {
        const videoElement = this.videoElement
        for (let i = 0; i < videoElement.length; i++) {
          this.videoElement[i].pause()
        }
        const audio = new Audio(audioUrl)
        audio.play()
        // 播放结束事件
        audio.onended = () => {
          this.player.id = null
          this.player.audio = null
        }
        this.player.id = id
        this.player.audio = audio
      }
    },
    formatAudioDuration(duration) {
      if (duration != null) {
        duration = Decimal.div(duration, 1000).toFixed(0)
        if (duration.length < 2) {
          duration = '0' + duration
        }
        return duration + '"'
      }
      return ''
    },
    HandleclickImg(photoUrls,index){
      ImagePreview({
        images: photoUrls,
        startPosition: index,
      });
    },
    deletedPost(postId, index) {
      Dialog.confirm({
        title: '温馨提示',
        message: '确定要删除此动态吗?',
      })
          .then(() => {
            Toast.loading({
              overlay: true,
              message: '请稍候...'
            })
            deletedPost(postId).then(res => {
              Toast.clear()
              const data = res.data;
              if (data.code == 0) {
                this.list.splice(index, 1)
                this.videoElement = document.getElementsByTagName('video')
                Toast.success('删除成功')
              } else {
                Toast.success('删除失败')
              }
            })
          })
          .catch(() => {

          });
    },
    handlePlay (index) {
      const videoElement = this.videoElement
      if (videoElement && videoElement.length > 0) {
        for (let i = 0; i < videoElement.length; i++) {
          if ( i === index) {
            this.videoElement[i].play()
            this.player.id = null
            this.player.audio = null
          } else {
            this.videoElement[i].pause()
          }
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.order-item {
  display: flex;
  align-items: center;

  .userMemo {
    color: #999;
  }

  .left {
    flex: 1;
    display: flex;

    .service-info {
      color: #333;
    }

    .created {
      color: #555;
      margin-bottom: 5px;
    }

    .user_head {
      position: relative;
      padding: 10px;
      .level {
        position: absolute;
        left: 50%;
        height: 12px;
        font-size: 10px;
        white-space: nowrap;
        bottom: 5px;
        transform: translateX(-50%);
      }

      .avatarFrame {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }

  .right {
    text-align: right;
    min-width: 30px;

    .total-amount {
      color: #333;
    }
  }
}
.bottom-bar {
  position: fixed;
  bottom: 0;
  padding: 10px 0;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);

  .bottom-button {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: none;
    background: var(--primary-color);
    color: white;
  }
}
</style>
